import i18next from 'i18next'

export default i18next;